import React from 'react';
import { Button, Badge, Card } from './ui';
import { FileText, Zap, ShieldCheck, Lock, Star, XCircle, CheckCircle, ArrowRight } from 'lucide-react';
export function Hero() {
  return <section className="relative pt-4 pb-16 md:pt-6 md:pb-24 px-4 overflow-hidden pl-[16px] pr-[16px]" data-id="element-12" data-mp="38xf3du36dhxr">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-teal-500/10 rounded-full blur-[120px] pointer-events-none" data-id="element-13" data-mp="3du5j2gb2ibin"></div>

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-14" data-mp="33xst9tin8ht6">
        <div className="inline-flex items-center gap-2 mb-4" data-id="element-15" data-mp="2q64c3btjf35c">
          <span className="text-2xl" data-id="element-16" data-mp="2q7z2h5nkvngt">🧩</span>
          <span className="text-teal-600 font-bold tracking-widest uppercase text-sm md:text-base" data-id="element-17" data-mp="2u7g5lsfj88it">
            PUNTO DIGITAL™
          </span>
        </div>

        <h1 className="md:text-6xl font-black text-navy mb-4 tracking-tight text-[26px]" data-id="element-18" data-mp="2g8q84bosw6tx">
          ¿Tu hijo no te hace caso
          <br data-id="element-19" data-mp="2motr3ekkl4g0" />
          <span className="text-teal-500 text-glow" data-id="element-20" data-mp="2mobziv8ureef">
            hasta que terminás levantando la voz?
          </span>
        </h1>

        <div className="relative mt-4 mb-6 flex justify-center" data-id="element-21" data-mp="2hoz2xis6isyn">
          <div className="absolute inset-0 bg-teal-500/15 blur-[80px] rounded-full pointer-events-none" data-id="element-22" data-mp="2vq1rc26ncfcq"></div>
          <img src="https://cdn.magicpatterns.com/uploads/vTAdqR1mo4KTmVfM83zDZp/mockup_landing_.png" alt="Kit de Conducta Infantil — los 3 tomos y los 5 bonos prácticos en formato digital" className="relative z-10 w-full max-w-lg h-auto drop-shadow-2xl pl-[45px] pr-[45px]" width={800} height={800} loading="eager" fetchPriority="high" decoding="async" data-id="element-23" data-mp="2qq71m1ylxvt9" />
        </div>

        <p className="md:text-xl text-navy mb-4 font-medium max-w-3xl mx-auto text-[16px]" data-id="element-24" data-mp="1ka3cfhosez3l">
          KIT DE CONDUCTA INFANTIL
        </p>

        <p className="text-ink-muted max-w-2xl mx-auto text-[14px] mt-[3px] mb-[3px]" data-id="element-25" data-mp="1faibx2tyyior">
          Herramientas prácticas para entender mejor su conducta, acompañar
          rabietas y emociones, poner límites claros y construir mejores rutinas
          sin convertir cada momento del día en una pelea.
        </p>

        <div className="flex flex-nowrap justify-center gap-2 mb-8 overflow-x-auto" data-id="element-26" data-mp="3p3ulfnu6qs4v">
          <Badge className="whitespace-nowrap" data-id="element-27" data-mp="3u14c16tb99ua">
            <FileText className="w-4 h-4 mr-2 text-teal-600" data-id="element-28" data-mp="2wengo74516b6" /> 100% Digital
          </Badge>
          <Badge className="whitespace-nowrap" data-id="element-29" data-mp="31dqkxpcan8i3">
            <Zap className="w-4 h-4 mr-2 text-amber-500" data-id="element-30" data-mp="31ejj41x6spom" /> Acceso inmediato
          </Badge>
          <Badge className="whitespace-nowrap" data-id="element-31" data-mp="36bs1o3m8yvqe">
            <span className="mr-2" data-id="element-32" data-mp="36f7j3d3e8guz">🧩</span> 3 Tomos + 5 Bonos
          </Badge>
        </div>

        <div className="flex flex-col items-center gap-6" data-id="element-33" data-mp="3acc2pi9xyjht">
          <Button size="md" className="w-full md:w-auto group" onClick={() => document.getElementById('planes')?.scrollIntoView({
          behavior: 'smooth'
        })} data-id="element-34" data-mp="llknum7hyhm3">
            <span className="mr-2 text-lg group-hover:scale-110 transition-transform" data-id="element-35" data-mp="264wr18rzk4hn">
              🧩
            </span>
            QUIERO MI KIT DE CONDUCTA INFANTIL AHORA
            <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-36" data-mp="21bttkpk38aw6" />
          </Button>

          <div className="flex flex-wrap justify-center items-center gap-6 text-sm text-ink-muted" data-id="element-37" data-mp="1rfqvbuscwwei">
            <span className="flex items-center" data-id="element-38" data-mp="1mgnoq5wqai4f">
              <ShieldCheck className="w-4 h-4 mr-1 text-emerald-600" data-id="element-39" data-mp="1mfw05f1jtknn" /> Garantía
              7 días
            </span>
            <span className="flex items-center" data-id="element-40" data-mp="1ifc3sdosul2k">
              <Lock className="w-4 h-4 mr-1 text-ink-soft" data-id="element-41" data-mp="1dgivczoddk99" /> Pago seguro
            </span>
            <span className="flex items-center" data-id="element-42" data-mp="3ctmvqv0oxvck">
              <Zap className="w-4 h-4 mr-1 text-teal-600" data-id="element-43" data-mp="3csbryv78wnlg" /> Acceso inmediato
            </span>
          </div>
        </div>
      </div>
    </section>;
}
export function Testimonials() {
  const placeholders = [{
    initials: '—',
    ring: 'bg-teal-100 text-teal-700'
  }, {
    initials: '—',
    ring: 'bg-emerald-100 text-emerald-700'
  }, {
    initials: '—',
    ring: 'bg-coral-100 text-coral-600'
  }];
  return <section className="py-10 bg-cream-100 border-y border-cream-300" data-id="element-44" data-mp="20gq2a084mjca">
      <div className="max-w-6xl mx-auto px-4" data-id="element-45" data-mp="1lsliesxc81rx">
        <div className="flex flex-wrap justify-center gap-6 md:gap-14 text-center mt-[22px] mb-[22px]" data-id="element-46" data-mp="1lrtl9do3dvzj">
          <div data-id="element-47" data-mp="1qkwfzp4lvbhb">
            <p className="text-3xl font-bold text-navy mb-1" data-id="element-48" data-mp="1qkmrk5z7lcdq">3</p>
            <p className="text-sm text-ink-muted uppercase tracking-wider" data-id="element-49" data-mp="1csycbttny7sj">
              Tomos prácticos
            </p>
          </div>
          <div data-id="element-50" data-mp="1grfmkm8drye6">
            <p className="text-3xl font-bold text-navy mb-1" data-id="element-51" data-mp="12tr1bdaeip8l">5</p>
            <p className="text-sm text-ink-muted uppercase tracking-wider" data-id="element-52" data-mp="12u930pfu1vnw">
              Bonos incluidos
            </p>
          </div>
          <div data-id="element-53" data-mp="o725pmj9sw7h">
            <p className="text-3xl font-bold text-navy mb-1" data-id="element-54" data-mp="o6ilu0a27xqt">100%</p>
            <p className="text-sm text-ink-muted uppercase tracking-wider" data-id="element-55" data-mp="o8vaewabp6cu">
              Digital
            </p>
          </div>
          <div data-id="element-56" data-mp="y5rcaj5puu8f">
            <p className="text-3xl font-bold text-navy mb-1 flex items-center justify-center gap-1" data-id="element-57" data-mp="y69f5ymvw6pb">
              <Zap className="w-7 h-7 fill-amber-400 text-amber-500" data-id="element-58" data-mp="t53khv9ny9d5" />
            </p>
            <p className="text-sm text-ink-muted uppercase tracking-wider" data-id="element-59" data-mp="1754mxf5ktouq">
              Acceso inmediato
            </p>
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-6" data-id="element-60" data-mp="124qngli1jn8b">
          {placeholders.map((p, idx) => <Card key={idx} className="bg-white" data-id="element-61" data-mp="1gxsgm119fcp8" data-mpi={idx}>
              <div className="flex gap-1 mb-4" data-id="element-62" data-mp="1bwcx4deqde8y">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 text-cream-400" data-id="element-63" data-mp="1pvmdpe6umadg" data-mpi={i} />)}
              </div>
              <p className="text-ink-soft italic mb-6" data-id="element-64" data-mp="1lvu0go6ifg1r">
                [INSERTAR TESTIMONIO REAL]
              </p>
              <div className="flex items-center gap-3" data-id="element-65" data-mp="1szbr1amhtvh6">
                <div className={`w-10 h-10 rounded-full flex items-center justify-center font-bold ${p.ring}`} data-id="element-66" data-mp="1xwty0vgya0mj">
                  {p.initials}
                </div>
                <div data-id="element-67" data-mp="27mn1taaupbg8">
                  <p className="font-bold text-ink-muted" data-id="element-68" data-mp="27nydrxeg9pif">
                    [INSERTAR TESTIMONIO REAL]
                  </p>
                  <p className="text-xs text-ink-faint" data-id="element-69" data-mp="2bo8iz7uf4bw8">—</p>
                </div>
              </div>
            </Card>)}
        </div>
      </div>
    </section>;
}
export function Problem() {
  return <section className="py-12 px-4" data-id="element-70" data-mp="2lklabz2hqdnt">
      <div className="max-w-3xl mx-auto" data-id="element-71" data-mp="2qmanbk99x1ej">
        <h2 className="text-2xl md:text-4xl font-bold text-center text-navy mb-5" data-id="element-72" data-mp="2ql93ore6z6l7">
          ¿Cuántas veces más vas a tener que repetir lo mismo?
        </h2>

        <p className="text-ink-muted text-center text-[16px] mt-[11px] mb-[11px]" data-id="element-73" data-mp="w785m8qgunm6">
          Querés que te escuche. Querés poner límites. Querés acompañarlo sin
          que todo termine en una discusión. Pero llega el momento real:
          “Guardá los juguetes.” Nada. “Vamos, guardá los juguetes.” Nada. “Te
          dije que guardes los juguetes.” Lo pedís. Lo repetís. Insistís.
          Intentás explicarle. Negociás. Te frustrás. Y terminás levantando la
          voz. Después pasa todo... y aparece la culpa: “No quería reaccionar
          así.”
        </p>

        <p className="text-lg font-bold text-center text-teal-600 mb-6" data-id="element-74" data-mp="3ofabgt5syvaf">
          No siempre es falta de paciencia. Muchas veces faltan herramientas
          claras para saber qué hacer EN ESE MOMENTO.
        </p>

        <Card className="bg-white border-coral-300 mb-6" data-id="element-75" data-mp="3ehm493r0fvbd">
          <ul className="space-y-3" data-id="element-76" data-mp="3ej6z6uh8lg9r">
            {['Guardar los juguetes termina en discusión', 'Apagar la tablet genera enojo o una rabieta', 'Bañarse se convierte en negociación', 'Vestirse a tiempo termina en conflicto', 'La hora de dormir parece otra batalla', 'Un simple “no” termina en llanto, enojo o frustración', 'Prometés mantener la calma pero terminás perdiendo la paciencia otra vez'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-77" data-mp="1zg3ed3otayh" data-mpi={i}>
                <XCircle className="w-6 h-6 text-coral-500 shrink-0 mt-0.5" data-id="element-78" data-mp="1zy71usoirgf" />
                <span className="text-ink-muted text-lg" data-id="element-79" data-mp="pqlmr28u6ldj">{item}</span>
              </li>)}
          </ul>
        </Card>

        <h3 className="text-2xl md:text-3xl font-bold text-center text-navy mb-8" data-id="element-80" data-mp="uq7wv2tdbli4">
          ¿Y si esta fuera la última semana en la que tenés que improvisar
          frente a estos momentos?
        </h3>

        <p className="text-lg font-bold text-center text-navy mb-3" data-id="element-81" data-mp="kw7n2nn55s32">
          Criar con respeto no significa dejarlo hacer lo que quiera.
        </p>
        <p className="text-ink-muted text-center text-[15px] mb-4" data-id="element-82" data-mp="1dfmx4v18c6lg">
          Y poner límites tampoco significa tener que gritar para que te
          escuche. Muchos padres terminan atrapados entre dos extremos: gritar
          para conseguir obediencia o ceder para evitar el conflicto.
        </p>
        <div className="flex flex-wrap justify-center gap-2 text-sm font-medium text-teal-600 mb-4" data-id="element-83" data-mp="37ts3lw1w8fw9">
          <span data-id="element-84" data-mp="32xbeayiyjvhl">Entender</span> <span className="text-ink-faint" data-id="element-85" data-mp="32ws5c7bachfp">→</span>
          <span data-id="element-86" data-mp="2f5mgx3ra4gts">Acompañar</span> <span className="text-ink-faint" data-id="element-87" data-mp="2f77bgtdlfzrn">→</span>
          <span data-id="element-88" data-mp="2a7b90ykjoge7">Poner límites</span> <span className="text-ink-faint" data-id="element-89" data-mp="2a84ii7aw1k01">→</span>
          <span data-id="element-90" data-mp="2a9fmo888wtro">Organizar</span>
        </div>
        <div className="grid sm:grid-cols-2 gap-3" data-id="element-91" data-mp="2o7ck16uix47e">
          {['Entender qué puede haber detrás de la conducta', 'Acompañar sus emociones sin abandonar el límite', 'Establecer límites con mayor claridad y consistencia', 'Crear rutinas que hagan el día más predecible'].map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-92" data-mp="3vmqojm2stkcg" data-mpi={i}>
              <CheckCircle className="w-5 h-5 text-emerald-600 shrink-0 mt-0.5" data-id="element-93" data-mp="42mrjzx5hv2k" />
              <span className="text-ink-muted" data-id="element-94" data-mp="1uh53cjlk4p">{item}</span>
            </div>)}
        </div>
        <p className="text-ink-muted text-center text-[15px] mt-6" data-id="element-95" data-mp="3rfyvndsfbdph">
          No necesitás tener una respuesta perfecta para todo. Necesitás
          herramientas que te ayuden a saber qué hacer cuando llega el momento
          difícil.
        </p>
      </div>
    </section>;
}